import { Component, OnInit } from '@angular/core';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'app-unavailable',
    templateUrl: './unavailable.component.html',
    styleUrls: ['./unavailable.component.scss'],
    standalone: false
})
export class UnavailableComponent implements OnInit, IWidgetComponent {
    data: Widget;

    constructor() { }

    ngOnInit() {
    }
}
